/* VEVO enhancements preserve the theme's native variant and cart behaviour. */
(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('.vevo-package-fieldset').forEach(fieldset => {
      if (fieldset.dataset.vevoReady) return;
      fieldset.dataset.vevoReady = 'true';
      const section = fieldset.closest('[data-section-type="product"]');
      if (!section) return;
      const sync = (colour, packageIndex) => {
        if (colour) section.querySelectorAll('[data-vevo-colour]').forEach(item => {
          item.hidden = item.dataset.vevoColour !== colour;
        });
        if (colour) section.querySelectorAll('[data-vevo-choose-colour]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.vevoChooseColour === colour));
        });
        if (packageIndex) section.querySelectorAll('[data-vevo-guide]').forEach(item => {
          const details = item.querySelector('details');
          if (details) details.open = item.dataset.vevoGuide === packageIndex;
        });
      };
      section.querySelectorAll('[data-vevo-choose-colour]').forEach(button => button.addEventListener('click', () => {
        const choice = Array.from(section.querySelectorAll('input[data-option-position="1"]')).find(input => input.value === button.dataset.vevoChooseColour);
        if (!choice) return;
        choice.checked = true;
        choice.dispatchEvent(new Event('change', {bubbles: true}));
      }));
      section.querySelectorAll('[data-vevo-configurations]').forEach(config => {
        const filters = Array.from(config.querySelectorAll('[data-vevo-config-filter]'));
        const panels = Array.from(config.querySelectorAll('[data-vevo-config-panel]'));
        const show = value => {
          filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.vevoConfigFilter === value)));
          panels.forEach(panel => { panel.hidden = panel.dataset.vevoConfigPanel !== value; });
        };
        const filterBar = config.querySelector('.vevo-config-filters');
        if (filterBar) filterBar.hidden = false;
        filters.forEach(button => button.addEventListener('click', () => show(button.dataset.vevoConfigFilter)));
        show('bassinet');
        config.querySelectorAll('.vevo-config-controls').forEach(controls => { controls.hidden = false; });
        config.querySelectorAll('[data-vevo-config-scroll]').forEach(button => button.addEventListener('click', () => {
          const rail = button.closest('[data-vevo-config-panel]').querySelector('.vevo-config-rail');
          const card = rail.querySelector('.vevo-config-card');
          if (!card) return;
          rail.scrollBy({left: Number(button.dataset.vevoConfigScroll) * (card.getBoundingClientRect().width + 18), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }));
      });
      section.addEventListener('variant:changed', event => {
        const variant = event.detail && event.detail.variant;
        const choice = fieldset.querySelector('input:checked');
        if (variant) sync(variant.option1, choice && choice.dataset.vevoPackageIndex);
      });
      section.querySelectorAll('[data-vevo-select]').forEach(link => link.addEventListener('click', () => {
        const choice = fieldset.querySelector(`[data-vevo-package-index="${link.dataset.vevoSelect}"]`);
        if (!choice) return;
        choice.checked = true;
        choice.dispatchEvent(new Event('change', {bubbles: true}));
        choice.focus({preventScroll: true});
      }));
      section.querySelectorAll('a[href^="#vevo-"],a[href="#rb-product-overview"],a[href="#rb-product-dimensions"]').forEach(link => link.addEventListener('click', event => {
        const target = section.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
